import { useRef } from "react";
import { $generateHtmlFromNodes } from "@lexical/html";
import { LexicalEditor } from "lexical";
import productCore from "../../../core/product.core";

export function useAutoSaveDraft(editor: LexicalEditor, productId?: string, key?: string) {
  const timerRef = useRef<any>(null);

  if (!productId || !key) return () => {};

  const scheduleSave = () => {
    clearTimeout(timerRef.current);

    timerRef.current = setTimeout(async () => {
      const editorState = editor.getEditorState();

      const json = editorState.toJSON();
      const html = editorState.read(() => $generateHtmlFromNodes(editor));

      await productCore.saveproductDescriptionDraft(productId, key, JSON.stringify(json, null, 2), html);

    }, 500);
  };

  return scheduleSave;
}
